const n = {
  id: "chartJsBackgroundColorPlugin",
  beforeDraw: (e, c, t) => {
    const {
      ctx: o,
      chartArea: { top: r, left: a, width: l, height: i }
    } = e;
    t.chartAreaBackgroundColor && (o.save(), o.globalCompositeOperation = "destination-over", o.fillStyle = t.chartAreaBackgroundColor, o.fillRect(a, r, l, i), o.restore()), t.backgroundColor && (o.save(), o.globalCompositeOperation = "destination-over", o.fillStyle = t.backgroundColor, o.fillRect(0, 0, e.width, e.height), o.restore());
  }
};
export {
  n as default
};
//# sourceMappingURL=index.es69.js.map
